import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Typography, useMediaQuery } from '@mui/material'
import { setVendorFilters } from '../../features/vendorSlice'
import FilterForm from './FilterForm'
import ButtonCustom from '../atoms/button/ButtonCustom'

import styles from './venderListStyle.module.scss'

const VenderFilter = () => {
	const dispatch = useDispatch()
	const [filterOpen, setFilterOpen] = useState('')
	const [clear, setClear] = useState(false)
	const isLaptopScreen = useMediaQuery('(max-width:899px)')
	const handleFilterOpen = () => {
		const body = document.querySelector('body')
		body.style.overflowY = 'hidden'
		setFilterOpen(true)
	}
	const handleFilterClose = () => {
		const body = document.querySelector('body')
		body.style.overflowY = 'auto'
		setFilterOpen(false)
	}
	return (
		<>
			{isLaptopScreen && (
				<ButtonCustom
					variant="outlined"
					size="lg"
					onClick={handleFilterOpen}
					className={styles.filterBtn}
				>
					<img src="/images/filter-icn.svg" alt="filter" />
					Filter
				</ButtonCustom>
			)}

			<div className={`${styles.filterWrp} ${filterOpen && styles.open}`}>
				<div className={styles.heading}>
					<Typography variant="h3">Filter</Typography>
					<span
						className={styles.clearAll}
						onClick={() => {
							dispatch(setVendorFilters({ page: 1, limit: 10 }))
							setClear(prev => !prev)
						}}
					>
						Clear all
					</span>
				</div>
				<div className={styles.filterForm}>
					<FilterForm clear={clear} />
				</div>
			</div>
			<div
				className={`${styles.filterOverlay} ${filterOpen && styles.active}`}
				onClick={handleFilterClose}
			></div>
		</>
	)
}

export default VenderFilter
